import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-padlock",
  "use": "icon-padlock-usage",
  "viewBox": "0 0 13 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 13 17\" id=\"icon-padlock\">\r\n<g>\r\n\t<path d=\"M10,17H3c-1.7,0-3-1.3-3-3V7.8c0-1.5,1.2-2.8,2.7-3C2.9,0.9,4.9,0,6.5,0s3.6,0.9,3.8,4.8C11.8,5,13,6.2,13,7.8V14\r\n\t\tC13,15.7,11.7,17,10,17z M3,6.8c-0.6,0-1,0.4-1,1V14c0,0.6,0.4,1,1,1h7c0.6,0,1-0.4,1-1V7.8c0-0.6-0.4-1-1-1H3z M4.7,4.7h3.6\r\n\t\tC8.1,2,7,2,6.5,2C6,2,4.9,2,4.7,4.7z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol